import { CATEGORY_PARENT_AND_NAME_DELIMITER } from "app/common/services/categoryService";
import type { ICategory } from "app/common/services/categoryService.types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const resolveCustomAttributes = (industry: ICategory) => {
    if (!industry || Object.keys(industry).length === 0) {
        return {};
    }
    const { isCustomCategory } = industry;
    const customAttributes = isCustomCategory
        ? resolveCustomAttributesCustomCategory(industry)
        : resolveCustomAttributesPreDefined(industry);
    return customAttributes;
};

const resolveCustomAttributesPreDefined = (industry: ICategory) => {
    const { id } = industry;
    const [main_category, sub_category] = id.split(CATEGORY_PARENT_AND_NAME_DELIMITER);
    return { main_category, sub_category };
};

const resolveCustomAttributesCustomCategory = (industry: ICategory) => {
    const internalSource = proNavigator.getParams().internalSource;

    const {
        isShared: is_shared_custom_category,
        categoryType: category_type,
        categoryId: custom_category_id,
        name: custom_category_name,
        domains,
        segments,
    } = industry;
    return {
        custom_category_id,
        custom_category_name,
        is_shared_custom_category,
        category_type,
        domains_amount: domains.length,
        segments_amount: segments.length,
        entities_amount: domains.length + segments.length,
        internal_source: internalSource,
    };
};
